/************************************************************
ChemicalSearch.tsx - To Search and Select required Gloves
*************************************************************/
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import "./ChemicalSearch.scss";
import Breadcrumb from '../../../common/Breadcrumb/Breadcrumb';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BsSearch } from 'react-icons/bs';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { setSelectedChemicalsArrayInStore } from "../../../../store/actions";
import Modal from "react-bootstrap/Modal";
import Loader from "../../../common/Loader/Loader";
import { ImgNoChemical, ImgAlert } from '../../../../components/dashboard/pages/glovesSelector/glovesSelection';
import { useGetChemicalsQuery } from "../../../../services/loadChemicals";
import { STORE_ACTION_TYPES } from "../../../../helper/constants";
import { setSelectedChemicalsInStore, setStyleNumbersInStore } from "../../../../store/actions";
import { addAnalytics, sendAnalyticData } from "../../../common/functions/utils";
import { kclRootState } from "../../../../store/gloveSelectorStore";
import { selectedChemicalsTypes, Calculator, selectChemicalType } from "../../../../types/allTypes";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { useGetStyleNumbersQuery } from "../../../../services/loadStyleNumbers";
import { utilAnalytics } from '../../../common/analytics/analyticsUtil';

const ChemicalSearch = () => {
  const [selectChemicals, setSelectChemicals] = useState<Array<selectedChemicalsTypes>>([]);
  const [showGlovesBtn, setshowGlovesBtn] = useState<boolean>(true);
  const selectedChemicalsArrayStore = useSelector((state: kclRootState) => state?.glovesSelector?.calculator?.selectedChemicalsArray || []);
  const [selectedChemicals, setSelectedChemicals] = useState<selectChemicalType>(selectedChemicalsArrayStore);

  const [totalRecords, settotalRecords] = useState<number>(0);
  const navigate = useNavigate();
  const { PAGE_NAVIGATION } = useSelector((state: kclRootState) => state?.glovesSelector?.config || {});
  const { t } = useTranslation();
  const [exceededChemicalSearchWarning, setExceededChemicalSearchWarning] = useState<boolean>(false);

  const closeWarningLimit = () => setExceededChemicalSearchWarning(false);
  // pagination changes start
  const dispatch = useDispatch();
  const { CONFIG_ROWS_PER_PAGE_OPTION, CONFIG_DEFAULT_PAGE_COLLECTION } = useSelector(
    (state: kclRootState) => state?.glovesSelector?.config || {}
  );
  const { rowsPerPageValue } = useSelector((state: kclRootState) => state?.glovesSelector?.calculator || {} as Calculator);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [startPage, setStartPage] = useState<number>(0);
  const pages = Math.ceil(totalRecords / rowsPerPageValue);
  const [numberOfPages, setNumberOfPages] = useState<number>(pages);
  const [lastPage, setLastPage] = useState<number>(
    numberOfPages < CONFIG_DEFAULT_PAGE_COLLECTION ? numberOfPages : CONFIG_DEFAULT_PAGE_COLLECTION
  );
  const [searchTermFind, setsearchTerm] = useState<string>("");
  const [fallBackMsg, setFallBackMsg] = useState<string>("");
  const [sucessMsg, setSucessMsg] = useState<boolean>(true);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const closeWarning = () => setShowAlert(false);

  const [defaultsearch, setDefaultSearch] = useState<boolean>(false);

  const language = useSelector((state: kclRootState) => state?.glovesSelector?.language || "en");
  const { data: styleNumbers } = useGetStyleNumbersQuery({
    payload: {},
    language: language
  });
  useEffect(() => {
    setStyleNumbersInStore(styleNumbers?.result?.styleNo);
  }, [styleNumbers]);

  const { data, isLoading } = useGetChemicalsQuery({
    payload: {
      "sort": {
        "sortBy": "chemicalName",
        "sortOrder": "asc"
      },
      "pagination": {
        "pageNumber": pageNumber + 1,
        "rows": rowsPerPageValue
      },
      "search": {
        "searchField": "",
        "searchText": defaultsearch === true ? searchTermFind : "",
      }
    },
    language: language
  }
  );

  //Generating Pages Array
  const range = (start, end, step = 1) => {
    const output: number[] = [];
    for (let i = start; i < end; i += step) {
      const value = i;
      output.push(value);
    }
    return output;
  };


  //Setting Page Number
  const setPageItems = (e) => {
    e.preventDefault();
    const pageIndex = parseInt(e.target.innerText);
    setPageNumber(pageIndex - 1);
    !searchTermFind && setDefaultSearch(false);
    window.scrollTo(0, 0);
  };
  const pagesOutput = range(
    startPage,
    numberOfPages < CONFIG_DEFAULT_PAGE_COLLECTION ? numberOfPages : lastPage
  );
  const pageLength = (pageNumber + 1) * rowsPerPageValue;
  const startPageIndex =
    pageNumber === 0
      ? 1
      : (pageLength < totalRecords ? pageLength : totalRecords) -
      (selectChemicals?.length - 1);

  //Increasing Page Count
  const increasePage = (e) => {
    let isstartpageLessthanNoOfPage = startPage + CONFIG_DEFAULT_PAGE_COLLECTION < numberOfPages;
    let isLastpageLessthanNoOfPage = lastPage + CONFIG_DEFAULT_PAGE_COLLECTION < numberOfPages;

    e.preventDefault();
    if (isstartpageLessthanNoOfPage) {
      setStartPage((prevValue) => prevValue + CONFIG_DEFAULT_PAGE_COLLECTION);
    }

    if (isLastpageLessthanNoOfPage) {
      setLastPage((prevValue) => prevValue + CONFIG_DEFAULT_PAGE_COLLECTION);
    } else {
      setLastPage(numberOfPages);
    }
  };

  //Decreasing Page Count
  const decreasePage = (e) => {
    e.preventDefault();
    const value = lastPage - startPage;
    let isStartPageGtZero = startPage - CONFIG_DEFAULT_PAGE_COLLECTION >= 0;
    let isStartPageGtDefaultPageCollection = lastPage - CONFIG_DEFAULT_PAGE_COLLECTION > CONFIG_DEFAULT_PAGE_COLLECTION;
    if (isStartPageGtZero) {
      setStartPage((prevValue) => prevValue - CONFIG_DEFAULT_PAGE_COLLECTION);
    }
    if (isStartPageGtDefaultPageCollection) {
      setLastPage((prevValue) => prevValue - value);
    } else {
      setLastPage(CONFIG_DEFAULT_PAGE_COLLECTION);
    }
  };
  //Using this function for setting rows per page value
  const setRowsPerPageValue = useCallback(
    (storeRowValue: string) => (e: React.ChangeEvent<HTMLSelectElement>) => {
      e.preventDefault();
      setPageNumber(0);
      dispatch({
        type: STORE_ACTION_TYPES.CALCULATOR,
        payload: { [storeRowValue]: Number(e.target.value) },
      });
      //setDefaultSearch(false);
    },
    [dispatch]
  );

  useEffect(() => {
    if ((selectedChemicals.length != 0) && (selectedChemicals.length <= 25)) {
      setshowGlovesBtn(false);
    }
    else if (selectedChemicals.length > 25) {

      setExceededChemicalSearchWarning(true);
      setshowGlovesBtn(true);
    }
    else {
      setshowGlovesBtn(true);
    }
  }, [selectedChemicals]);
  useEffect(() => {
    setPageNumber(0);
    setNumberOfPages(pages);
    setStartPage(0);
    setLastPage(CONFIG_DEFAULT_PAGE_COLLECTION);
    setSelectChemicals(data?.result?.chemicalList);
    settotalRecords(data?.result?.totalRecords);
    /* eslint-disable */
  }, [searchTermFind, totalRecords, rowsPerPageValue]);
  const totalRecordsforAnalytics = data?.result?.totalRecords;
  useEffect(() => {
    const totalRecords = data?.result?.totalRecords;
    setSelectChemicals(data?.result?.chemicalList);
    settotalRecords(totalRecords);
    setSucessMsg(data?.isSuccess);
    const isSuccess = data?.isSuccess;

    if (isSuccess == true) {
      if (totalRecords == 0) {
        setFallBackMsg(t("kclGloves.No_Results_Found"));
      }
    }
    else {
      setShowAlert(true);
      setFallBackMsg(t("kclGloves.Unable_connect_server"));
    } ""

  }, [data])
  function ClearAllClicked() {
    setSelectedChemicals([]);
  }
  const handleChangeChemicals = (id: string | undefined) => {
    const selectedChemicalIds = selectedChemicals?.map((selectedChemical) => selectedChemical?.val?.[0]?.chemicalId);
    const val = selectChemicals.filter((item) => {
      if (item?.chemicalId == id) {
        return item;
      }
    })
    if (selectedChemicals?.length < 25) {
      setSelectedChemicals((oldArray: selectChemicalType) => { return [...oldArray, { val }] });
      setExceededChemicalSearchWarning(false)
    }
    else if (selectedChemicals?.length > 25 || (!selectedChemicalIds?.includes(id) && selectedChemicals?.length >= 24)) {
      setExceededChemicalSearchWarning(true);
      const customData = {
        "event": "chemicalsSelectedExceeded",
        text: "chemicals Selected Exceeded Maximum Limit"
      };
      addAnalytics(customData);
    }
    selectedChemicals.map((item) => {
      if (item?.val[0]?.chemicalId == id) {
        setSelectedChemicals(selectedChemicals.filter((data) => data?.val[0]?.chemicalId != id));
        return
      }
    })
  }

  const handleChangeChemicalsDelete = (id: number) => {
    setSelectedChemicals(selectedChemicals.filter((data) => data?.val[0]?.chemicalId != id));
  }
  // search functionality

  //Setting Search Value
  const setSearchHandler = (event) => {
    setDefaultSearch(true);
    setsearchTerm(event.target.value);
  }
  const debounce = (func) => {
    let timer;
    return function (this: [], ...args) {
      const context = this;
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    }
  }

  const handlerEnter = (e) => {
    if (e.keyCode === 13) {
      const customData = {
        "event": "searchClick",
        searchKeyword: searchTermFind,
        searchResultNumber: totalRecords
      }
      addAnalytics(customData);
      console.warn(fallBackMsg)
      searchTermFind != "" && utilAnalytics(
        true,
        {
          event: "searchClick",
          _honeywellinternationalinc:
          {
            search:
            {
              searchTerm: searchTermFind,
              searchResults: `${totalRecordsforAnalytics == 0 || totalRecords == 0 ? 0 : totalRecordsforAnalytics || totalRecords}`,
              secondarySearchTerm: "",
              searchCategory: "GS-Chemical Selection", // GS-Chemical Selection or GS-Gloves Selection or GS-Info Area"
              allSearches: { "value": 1 },
              unsuccessfulSearches:
              {
                value: totalRecordsforAnalytics == 0 || totalRecords == 0 ? 1 : 0
              }
            }

          }

        },
        "/chemical-search"
      );
    }
  }
  //adobe analytics data push
  const quickLinksSendAnalytics = (eventName, chemicalSelected, selectChemicalsClicked, path) => {
    const { protocol, host } = window.location;
    utilAnalytics(
      true,
      {
        event: eventName,
        _honeywellinternationalinc:
        {
          selectChemicals:
          {
            chemicalSelected: `${chemicalSelected}`,
            selectChemicalsClicked: { "value": 1 }
          }
        }
      },
      path
    );
  };
  // end search functionality
  const navigateToChemicalResults = () => {
    let chemicalIDArray: string[] = [];
    let chemicalNameArray: string[] = [];
    if (showGlovesBtn == false) {
      selectedChemicals?.map((val: any) => {
        chemicalIDArray.push(val?.val[0]?.chemicalId);
        chemicalNameArray.push(val?.val[0]?.chemicalName);
      });
      setSelectedChemicalsInStore(chemicalIDArray);
      // sendAnalyticData("showGloves", chemicalNameArray.join('|'), "chemicalSelected");
      quickLinksSendAnalytics("chemicalSelected", chemicalNameArray.join('|'), chemicalNameArray.length, "/chemical-results")
      setSelectedChemicalsArrayInStore(selectedChemicals);
      navigate(PAGE_NAVIGATION.CHEMICAL_RESULTS);
      window.scrollTo(0, 0);
    }
  };

  const onBackButtonClick = () => {
    setExceededChemicalSearchWarning(false);
  }
  const errorBack = () => {
    navigate(PAGE_NAVIGATION.HOME);
  }
  const errorRefresh = () => {
    navigate(PAGE_NAVIGATION.HOME);
  }

  return (
    <>
      <Breadcrumb />
      <div className="chemical-search">
        <div className='main-title'>
          <div className="textstart">
            <div className='heading'>{t("kclGloves.Select_Chemicals")} </div>
          </div>
          <div className="text-end search-bar">
            <span className='search-icon'><BsSearch /></span>
            <input value={searchTermFind} type='text' placeholder={t("kclGloves.Search_Chemical_Name_CAS")} onChange={setSearchHandler} onKeyDown={handlerEnter} />
          </div>
        </div>
        {isLoading && <><Loader /></>}
        {!isLoading &&
          <div className='row px-0'>

            {totalRecords == 0 || sucessMsg == false ? (
              <>{totalRecords == 0 ? <>
                <div className='col-md-8 col-12 no-results-found'>
                  <div className='title'>{fallBackMsg}</div>
                  <div className='subTitle'>'{searchTermFind}' {t("kclGloves.Please_Try_Later")}</div>
                </div>
              </> : <>

                <Modal show={showAlert} onHide={closeWarning} animation={false} aria-labelledby="MaxFilterWarning" centered className="facet-maxfilter-modal">
                  <Modal.Body className="mx-2">
                    <div className="row mx-0">
                      <div className="col-sm-2">
                        <img src={ImgAlert} alt="Warning" className="warning-icon" />
                      </div>
                      <div className="col-sm-10">
                        <div className="heading">{t("kclGloves.Error")}</div>
                        {fallBackMsg}
                      </div>
                    </div>
                    <div className='cta-btns mt-3 text-end'>
                      <div className="button button-outline" onClick={errorRefresh}>{t("kclGloves.Restart")}</div>
                      <div className="button button-primary" onClick={errorBack}>{t("kclGloves.Go_Back")}</div>
                    </div>
                  </Modal.Body>
                </Modal>
              </>}

              </>
            ) : (
              <>
                <div className='col-md-8 col-12'>
                  <div className="chemicals-table">
                    <div className="panel-body">
                      <div className="table-head">
                        <div className="table-items">{t("kclGloves.CHEMICALS")} </div>
                        <div className="table-items">{t("kclGloves.CAS_NUMBERS")}</div>
                        <div className="table-items">{t("kclGloves.COMMENTS")}</div>
                      </div>
                      {selectChemicals?.map((item) => (
                        <>
                          <div className={selectedChemicals.find(chemical => chemical?.val[0]?.chemicalId === item?.chemicalId) ? 'row-selected' : 'row-entries'} key={item?.chemicalId}>
                            <div className="table-data">
                              <div className='checkbox' key={item?.chemicalId}>
                                <div className='checkbox-input' >
                                  <input type='checkbox' id={item?.chemicalId} onChange={() => { handleChangeChemicals(item?.chemicalId) }} aria-label='Chemical Select' checked={selectedChemicals.find(chemical => chemical?.val[0]?.chemicalId === item?.chemicalId) ? true : false} />
                                </div>
                              </div>
                              <div><span className='chemicals-mobile'>{t("kclGloves.CHEMICALS")}</span> {item?.chemicalName} <div className='chemicals-status'>{item?.physicalState}</div></div>
                            </div>
                            <div className="table-data"><span className='chemicals-mobile'>{t("kclGloves.CAS_NUMBERS")}</span> {item?.chemCombiCas}</div>
                            <div className="table-data">{item?.comments !== 'NA' && (item?.comments || "").toString()?.length > 0 ? <span><span className='chemicals-mobile'>{t("kclGloves.COMMENTS")} </span> <span className='comments-desktop'>{item?.comments}</span></span> : <span className='na-hide-mobile'>NA</span>} </div>
                          </div>
                        </>
                      ))
                      }
                    </div>
                  </div>
                  <div className="chemical-pagination">
                    <div className="pages-count">
                      {selectChemicals?.length == 0 ? (
                        <p></p>
                      ) : (
                        <p aria-hidden="true">
                          {" "}
                          {startPageIndex} -{" "}
                          {(pageNumber + 1) * rowsPerPageValue < totalRecords
                            ? (pageNumber + 1) * rowsPerPageValue
                            : totalRecords}{" "}
                          / {totalRecords} {t("kclGloves.Rows")}
                        </p>
                      )}
                    </div>
                    <div className="page-numbers">
                      <ul>
                        {startPage >= 4 && numberOfPages > 1 &&
                          <li className={`arrow ${(pagesOutput.includes(0)) ? "arrow-disabled" : ""}`}><a href="#" onClick={decreasePage}><MdOutlineKeyboardArrowLeft className='arrows' /></a></li>
                        }
                        {pagesOutput.map((itemIndex, index) => (
                          <li
                            key={index}
                            className={`${itemIndex === pageNumber ? "active" : ""
                              }`}
                          >
                            <a href="#" onClick={setPageItems}>
                              {itemIndex + 1}
                            </a>
                          </li>
                        ))}
                        {(lastPage != numberOfPages && numberOfPages > 1 && pagesOutput.length != numberOfPages) &&
                          <li className={`arrow ${pagesOutput.includes(pages - 1) ? " arrow-disabled" : ""}`}><a href="#" onClick={increasePage}><MdOutlineKeyboardArrowRight className='arrows' /></a></li>
                        }
                      </ul>
                    </div>
                    <div className="rows-pages">
                      <span> {t("kclGloves.Rows")}</span>
                      <select className="form-control" aria-label="Rows per page" value={(rowsPerPageValue)} onChange={setRowsPerPageValue("rowsPerPageValue")}>
                        {CONFIG_ROWS_PER_PAGE_OPTION?.map((val: number, key: number) => {
                          return (
                            <option key={key} value={val}>{val}</option>
                          );
                        })}
                      </select>
                      <MdKeyboardArrowDown className="angle-down-arrow" />
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className='col-md-4 col-12'>
              <div className='chemicals-selected'>
                <div className="panel-heading">
                  <div>{t("kclGloves.CHEMICALS_SELECTED")}<span>{t("kclGloves.Max_25")}</span> </div>
                  <div className='selected'>{selectedChemicals.length == 0 ? " " : selectedChemicals.length + t("kclGloves.Selected")}</div>
                </div>
                <div className="panel-body">
                  <div className='checked-list'>
                    {selectedChemicals?.map((item) => {
                      if (item) {
                        return (
                          <div className='selected-item' key={item?.chemicalId}>
                            {item?.val[0]?.chemicalName} <span onClick={() => handleChangeChemicalsDelete(item?.val[0]?.chemicalId)}>x</span>
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })
                    }

                  </div>
                  {selectedChemicals?.some((item) => item?.val[0].chemicalId) ? null : (
                    <div className='no-chemicals'>
                      <img src={ImgNoChemical} alt='No chemicals selected' />
                      <div className='title'>{t("kclGloves.No_Chemicals_Selected")}</div>
                      <div className='sub-title'>{t("kclGloves.Selected_Chemicals_Display_Here")}</div>
                    </div>
                  )}
                </div>
                <div className='cta-btns px-2'>
                  <div onClick={ClearAllClicked} className={showGlovesBtn ? 'button button-disabled mb-2' : 'button button-primary mb-2'} >{t("kclGloves.Clear_All")}</div>
                  <div onClick={navigateToChemicalResults} className={showGlovesBtn ? 'button button-disabled mb-4' : 'button button-primary mb-4'} >{t("kclGloves.SHOW_GLOVES")}</div>
                </div>
              </div>
            </div>
          </div>
        }
        <div className="errorhandling">
          <Modal show={exceededChemicalSearchWarning} onHide={closeWarningLimit} animation={false} aria-labelledby="MaxFilterWarning" centered className="facet-maxfilter-modal">
            <Modal.Header closeButton>
              <Modal.Title>
                <div className="filters-alert">
                  <img src={ImgAlert} alt="Maximum 10 Filters" className="warning-icon" />
                  {t("kclGloves.MaxChemicalsTitle")}
                </div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="mx-2">
              <div className="row mx-0">
                <div className="row mx-0">
                  <p>{t("kclGloves.CHEMICAL_SEARCH_WARNING_LABELS")}</p>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default ChemicalSearch;